import { constants } from '../../constants';
import { ActivityInfo, Chatroom } from '../../models';
import axios from 'axios';

export const getActivityInfo = (room: Chatroom) => {
  const token = localStorage.getItem('token');
  return axios.get<ActivityInfo>(
    `${constants.endpoint}/activities/${room.activity.id}`,
    {
      params: {
        chatroomId: room.id,
      },
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
};
